// Android APK build metadata — fallback for /downloads/latest.json (kept in sync by mobile/build-android.sh).
export const APK = {
  path: "/downloads/manasik-guide-v1.0.11.apk",
  version: "1.0.11",
  versionCode: 12,
  sizeMb: "2,4",
  packageId: "com.manasikguide.beginner",
  sha256: "009e8b2f2fba6e50d39268cddc94d8f1d305402881caf792d3c6ba2b9abdb5be",
};

export const LATEST_URL = "/downloads/latest.json";
export const apkUrl = (path = APK.path) => `${window.location.origin}${path}`;
export const installPageUrl = () => `${window.location.origin}/install`;
